import { GraphQLClient } from 'graphql-request'

const apolloFederationUrl = process.env.VUE_APP_APOLLO_FEDERATION_URL

export const GraphqlClient = new GraphQLClient(apolloFederationUrl)

export default {
  install(Vue) {
    Vue.prototype.$graphql = GraphqlClient

    Vue.prototype.$gqlSurveyRequest = async function (query, variables = {}, token = null) {
      const accountId = this.$store.state.surveyAccountId
      if (accountId) {
        this.$graphql.setHeader('accountid', accountId)
      }

      if (token) {
        this.$graphql.setHeader('authorization', `Bearer ${token}`)
      }

      return this.$graphql.request(query, variables)
    }
  }
}
